var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 86,
    viewBox: "0 0 106 86",
    fill: "none",
    id: "svg476",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 83.4613,16.1551 V 86 h 11.578 C 101.094,86 106,81.026 106,74.9015 V 2.47101 c 0,-2.09261199 -2.404,-3.23204199 -3.997,-1.89540199 z",
    fill: "url(#paint0_linear_11985_190892)",
    id: "path453",
    style: {
      fill: "url(#paint0_linear_11985_190892)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 67.3128,29.7407 46.1604,48.6618 c -3.6066,3.2211 -8.9895,3.2978 -12.6827,0.1862 L 0,20.6691 V 2.482 C 0,0.38939001 2.40441,-0.76099599 3.99653,0.57564301 L 45.998,35.8761 c 4.0615,3.4183 9.9534,3.4183 14.0149,0 z",
    fill: "url(#paint1_linear_11985_190892)",
    id: "path455",
    style: {
      fill: "url(#paint1_linear_11985_190892)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.4613,16.1661 -16.1485,13.5746 0.0108,-10e-5 -21.1632,18.9212 c -3.6066,3.2211 -8.9895,3.2978 -12.6827,0.1862 L 0,20.6691 V 74.9015 C 0,81.0259 4.9063,86 10.9607,86 h 72.5006 z",
    fill: "url(#paint2_radial_11985_190892)",
    id: "path457",
    style: {
      fill: "url(#paint2_radial_11985_190892)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs474"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11985_190892",
    x1: 265.97501,
    y1: 141.754,
    x2: 244.3,
    y2: -73.404099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#E3D9FF",
    id: "stop459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7341FF",
    id: "stop461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11985_190892",
    x1: 62.634602,
    y1: 86.798401,
    x2: 18.552999,
    y2: -87.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3D9FF",
    id: "stop464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7341FF",
    id: "stop466"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_11985_190892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(123.614,0,0,125.045,105.538,10.5272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    stopColor: "#6D4AFF",
    id: "stop469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#AA8EFF",
    id: "stop471"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.bc5e3bc472f3dfb0429f940ea453706e.svg";
export { ForwardRef as ReactComponent };